import axios from 'axios'

export default () => {
    let ax = axios.create({
        baseURL: "https://ebelgebasvuru.gib.gov.tr/api/v1",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
    })
    ax.interceptors.response.use((response) => {
        return response
    }, (error) => {
        return error.response
    })
    return ax
}
